import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Grid, Row} from "react-bootstrap";
import { Link } from "react-router-dom";
import Button from "components/CustomButton/CustomButton.jsx";
import { setMessage } from "../../../../redux/actions/status";
import NomForm from './NomForm';

class NomResult extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            vProductNom: '',
            vNom: '',
            nomSubstance: '',
            result: {
                status:null,
                data:"Après avoir selectionner vos données appuyer sur le button ci-dessous pour lancer l'analyse "
            }
        }
    }
    onChangeProduct = product => {
        this.state.vNom = product.value.toLowerCase();
    }

    onChangeSubstance = substance => {
        
        if(substance.nomsCommerciauxContreIndiquees== undefined){
            substance.nomsCommerciauxContreIndiquees =''
        }
        if(substance.nomsCommerciauxContreIndiquees.includes(',')){
            this.state.vProductNom = substance.nomsCommerciauxContreIndiquees.split(",");
            this.state.nomSubstance = substance.label.toUpperCase();
        }
        else{
            this.state.vProductNom = substance.nomsCommerciauxContreIndiquees;
            this.state.nomSubstance = substance.label.toUpperCase();
        }
        }
        
    onSubmit(event) {
        event.preventDefault();
        this.state.vNom.toLowerCase();
        if(this.state.nomSubstance==''||this.state.vNom == ''){
            this.setState({result: {status:0, data:"VEUILLEZ SELECTIONNER LES DONNEES A ANALYSER !"}});
            this.props.setMessage({ message: "Champ vide !", status: "danger" });
        }
        else if(this.state.vProductNom.indexOf(this.state.vNom) != -1){
            this.setState({result: {status:1, data:"< "+this.state.nomSubstance+" > "+" est contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >"}});
            this.props.setMessage({ message: "< "+this.state.nomSubstance+" > "+" est contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >", status: "warning" });
        } else{
            this.setState({result: {status:-1, data:"< "+this.state.nomSubstance+" > "+" n'est pas contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >"}});
            this.props.setMessage({ message: "< "+this.state.nomSubstance+" > "+" n'est pas contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >", status: "success" });
        }  
       
    }
    
    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                <Row>
                    <Col md={12} style={{ marginBottom: "16px" }}>
                        <Link to="/app/analyse/analyses">
                            <Button bsStyle="default" fill bsSize="lg">
                                Retour
                            </Button>
                        </Link>
                    </Col>
                </Row>
                    <Col sm={12}>
                        <form onSubmit={this.onSubmit}>
                            <NomForm
                                onChangeSubstance = {this.onChangeSubstance}
                                onChangeProduct = {this.onChangeProduct}
                                result={this.state.result}
                            />
                        </form>
                    </Col>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        substance: state.substances.substance,        
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setMessage: (message) => {
            dispatch(setMessage(message));
        }
    }
};
  
NomResult.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    setMessage: PropTypes.func,
    Substance: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(NomResult);